import { fieldRegistry } from "sulu-admin-bundle/containers/index.js";

import YTLink from "./YTLink";
import TeamsDragger from "./TeamsDragger";
import UniformSVG from "./UniformSVG";
import HeaderField from "./HeaderField";
import ReportEvents from "./ReportEvents";
import LabelCustom from "./LabelCustom";
import RefereeApproval from "./RefereeApproval";
import DHBLabel from "./DHBLabel";
import EmptyType from "./EmptyType";
import RecapList from "./RecapList";
import CustomList from "./CustomList";
import LiveTicker from "./Liveticker/LiveTicker.js";
import MatchDaysPage from "../components/MatchDays/matchDaysLayout.js";
import TeamAuthorization from "./TeamAuthorization/TeamAuthorization.js";
import TableDetails from "./TableDetails/TableDetails.js";
import OccupancyPlan from "./OccupancyPlan/components/OccupancyPlan.js";
import DateCustom from "./DatePicker/DatePicker.js";
import PlayerSearch from "./PlayerSearch/PlayerSearch.js";
import CustomDocumentUpload from "./CustomDocumentUpload/CustomDocumentUpload.js";
import CustomMediaReadonly from "./CustomMediaReadonly/CustomMediaReadonly.js";
import ExternalLink from "./ExternalLink";
import MemberSelection from "./MemberSelection/MemberSelection.js";
import PlayerRecapPage from "../components/PlayerRecapTable/PlayerRecapPage.js";
import UmpireCostsPage from "../components/UmpireCosts/UmpireCostsPage.js";
import PassportStatisticsPage from "../components/PassportStatistics/PassportStatisticsPage.js";

const customListsArr = [
    "member_selection",
    "dhbplayer_selection_match",
    "dhbclubmember_selection",
    "dhbstaff_selection_match",
    "dhbplayer_match_report",
    "dhbumpire_selection_match",
    "limited_umpire_selection_match",
    "dhbumpire_costs",
    "limited_dhbumpire_costs",
    "dhbstaff_match_report",
];

// Custom field registration logic
fieldRegistry.__proto__.add = function (name, field, options) {
    if (customListsArr.indexOf(name) === -1 && name in this.fields) {
        throw new Error(
            `The key "${name}" has already been used for another field`,
        );
    }

    if (customListsArr.indexOf(name) > -1 && this.fields[name]) {
        this.options[name] = options;
        return;
    }

    this.fields[name] = field;
    this.options[name] = options;
};

const registerFields = () => {
    fieldRegistry.add("yt_link", YTLink);
    fieldRegistry.add("teams_dragger", TeamsDragger);
    fieldRegistry.add("unifrom_svg", UniformSVG);
    fieldRegistry.add("header_field", HeaderField);
    fieldRegistry.add("report_events", ReportEvents);
    fieldRegistry.add("label_custom", LabelCustom);
    fieldRegistry.add("referee_approval", RefereeApproval);
    fieldRegistry.add("dhb_label", DHBLabel);
    fieldRegistry.add("empty_space", EmptyType);
    fieldRegistry.add("recap_list", RecapList);

    fieldRegistry.add("dhbplayer_selection_match", CustomList);
    fieldRegistry.add("dhbstaff_selection_match", CustomList);
    fieldRegistry.add("dhbumpire_selection_match", CustomList);
    fieldRegistry.add("limited_umpire_selection_match", CustomList);
    fieldRegistry.add("dhbumpire_costs", CustomList);
    fieldRegistry.add("limited_dhbumpire_costs", CustomList);
    fieldRegistry.add("dhbstaff_match_report", CustomList);

    fieldRegistry.add("dhbmatches_live_ticker", LiveTicker);
    fieldRegistry.add("match_day_custom", MatchDaysPage);
    fieldRegistry.add("authorization_team", TeamAuthorization);
    fieldRegistry.add("table_details", TableDetails);
    fieldRegistry.add("occupancy", OccupancyPlan);
    fieldRegistry.add("date_custom", DateCustom);
    fieldRegistry.add("player_search", PlayerSearch);
    fieldRegistry.add("custom_document", CustomDocumentUpload);
    fieldRegistry.add("custom_media_readonly", CustomMediaReadonly);
    fieldRegistry.add("external_link", ExternalLink);
    fieldRegistry.add("member_selection", MemberSelection);
    fieldRegistry.add("player_recap", PlayerRecapPage);
    fieldRegistry.add("umpire_costs_page", UmpireCostsPage);
    fieldRegistry.add("passport_statistics_page", PassportStatisticsPage);
};

export default registerFields;
